import { Component } from 'components'
import throttle from 'lodash.throttle'


// TODO: make work with any container
class ActiveContent extends Component {
  constructor () {
    super()
    this.state = {
      activeId: null,
    }
    this.throttledUpdate = throttle(() => {
      setTimeout(this.update.bind(this), 0)
    }, 60)
  }
  shouldComponentUpdate (nextProps, nextState) {
    return nextState.activeId !== this.state.activeId
      || nextProps.idList !== this.props.idList
  }
  update () {
    let { offsetTop: filterTop=200 } = this.props
    let nextId = null
    this.props.idList.forEach(id => {
      const elem = document.getElementById(id)
      if (!elem) return
      const elemTop = elem.getBoundingClientRect().top
      if (elemTop <= filterTop) {
        nextId = id
        return
      }
      filterTop = elemTop
    })
    if (nextId === this.state.activeId) return
    this.setState({ activeId: nextId })
  }
  componentDidMount () {
    // this.update()
    window.addEventListener('scroll', this.throttledUpdate)
    window.addEventListener('resize', this.throttledUpdate)
  }
  componentWillUnmount () {
    window.removeEventListener('scroll', this.throttledUpdate)
    window.removeEventListener('resize', this.throttledUpdate)
  }
  render () {
    return this.props.children(this.state.activeId)
  }
}

export default ActiveContent



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ActiveContent.js